class Developer {
    id;
    name;
    description;
    highlights;
    photoURL;
    websiteLink;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.highlights = data.highlights;
        this.photoURL = data.photoURL;
        this.websiteLink = data.websiteLink;
    }
}
export default Developer;
